"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9974],{

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_0__);





function Image(_param) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "sx"
    ]);
    if (ratio) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            component: "span",
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                width: 1,
                lineHeight: 0,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: getRatio(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_0__.LazyLoadImage,
                wrapperClassName: "wrapper",
                effect: disabledEffect ? undefined : effect,
                placeholderSrc: "/assets/placeholder.svg",
                sx: {
                    width: 1,
                    height: 1,
                    objectFit: "cover"
                }
            }, other))
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_0__.LazyLoadImage,
            wrapperClassName: "wrapper",
            effect: disabledEffect ? undefined : effect,
            placeholderSrc: "/assets/placeholder.svg",
            sx: {
                width: 1,
                height: 1,
                objectFit: "cover"
            }
        }, other))
    });
}
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}


/***/ }),

/***/ 85259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/contexts/CollapseDrawerContext.tsx
var CollapseDrawerContext = __webpack_require__(44237);
;// CONCATENATED MODULE: ./src/hooks/useCollapseDrawer.ts


var useCollapseDrawer = function() {
    return (0,react.useContext)(CollapseDrawerContext/* CollapseDrawerContext */.y);
};
/* harmony default export */ var hooks_useCollapseDrawer = (useCollapseDrawer);

// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./src/hooks/useSettings.ts
var useSettings = __webpack_require__(10901);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@clerk/nextjs/dist/index.js
var dist = __webpack_require__(16855);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(72389);
// EXTERNAL MODULE: ./src/components/animate/IconButtonAnimate.tsx
var IconButtonAnimate = __webpack_require__(28683);
// EXTERNAL MODULE: ./src/components/other/Iconify.tsx + 1 modules
var Iconify = __webpack_require__(61367);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/SettingsButton.tsx





function SettingsButton() {
    var ref = (0,useSettings/* default */.Z)(), open = ref.open, setOpen = ref.setOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
        arrow: true,
        title: "Instellingen",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
            id: "fade-button",
            onClick: function() {
                return setOpen(!open);
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                icon: "la:cog"
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/other/Logo.tsx
var Logo = __webpack_require__(89915);
;// CONCATENATED MODULE: ./src/hooks/useOffSetTop.ts

function useOffSetTop(top) {
    var ref = (0,react.useState)(false), offsetTop = ref[0], setOffSetTop = ref[1];
    var isTop = top || 100;
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            if (window.pageYOffset > isTop) {
                setOffSetTop(true);
            } else {
                setOffSetTop(false);
            }
        });
        return function() {
            window.onscroll = null;
        };
    }, [
        isTop
    ]);
    return offsetTop;
}

// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/components/other/Image.tsx
var Image = __webpack_require__(70880);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(43963);
;// CONCATENATED MODULE: ./src/components/other/MenuPopover.tsx







var ArrowStyle = (0,styled/* default */.ZP)("span")(function(param) {
    var arrow = param.arrow, theme = param.theme;
    var SIZE = 12;
    var POSITION = -(SIZE / 2);
    var borderStyle = "solid 1px ".concat(theme.palette.grey[50012]);
    var topStyle = {
        borderRadius: "0 0 3px 0",
        top: POSITION,
        borderBottom: borderStyle,
        borderRight: borderStyle
    };
    var bottomStyle = {
        borderRadius: "3px 0 0 0",
        bottom: POSITION,
        borderTop: borderStyle,
        borderLeft: borderStyle
    };
    var leftStyle = {
        borderRadius: "0 3px 0 0",
        left: POSITION,
        borderTop: borderStyle,
        borderRight: borderStyle
    };
    var rightStyle = {
        borderRadius: "0 0 0 3px",
        right: POSITION,
        borderBottom: borderStyle,
        borderLeft: borderStyle
    };
    return (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up("sm"), {
        zIndex: 1,
        width: SIZE,
        height: SIZE,
        content: "''",
        display: "block",
        position: "absolute",
        transform: "rotate(-135deg)",
        background: theme.palette.background.paper
    }), arrow === "top-left" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topStyle), {
        left: 20
    }), arrow === "top-center" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "top-right" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topStyle), {
        right: 20
    }), arrow === "bottom-left" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bottomStyle), {
        left: 20
    }), arrow === "bottom-center" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bottomStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "bottom-right" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bottomStyle), {
        right: 20
    }), arrow === "left-top" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, leftStyle), {
        top: 20
    }), arrow === "left-center" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, leftStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "left-bottom" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, leftStyle), {
        bottom: 20
    }), arrow === "right-top" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rightStyle), {
        top: 20
    }), arrow === "right-center" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rightStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "right-bottom" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rightStyle), {
        bottom: 20
    }));
});
function MenuPopover(_param) {
    var children = _param.children, _arrow = _param.arrow, arrow = _arrow === void 0 ? "top-right" : _arrow, disabledArrow = _param.disabledArrow, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "arrow",
        "disabledArrow",
        "sx"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Popover/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        PaperProps: {
            sx: (0,_object_spread/* default */.Z)({
                p: 1,
                width: 200,
                overflow: "inherit"
            }, sx)
        }
    }, other), {
        children: [
            !disabledArrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowStyle, {
                arrow: arrow
            }),
            children
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 39 modules
var esm = __webpack_require__(30702);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/hooks/useLocales.ts









// TODO: @Joey Local first, then clerk
function useLocales() {
    var user = (0,dist.useUser)().user;
    var ref = (0,router.useRouter)(), push = ref.push, asPath = ref.asPath;
    var onChangeDirectionByLang = (0,useSettings/* default */.Z)().onChangeDirectionByLang;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var langStorage = (0,react.useMemo)(function() {
        return (user === null || user === void 0 ? void 0 : user.unsafeMetadata.lang) || config/* defaultLang.value */.Fp.value;
    }, [
        user
    ]);
    var ref1;
    var currentLang = (0,react.useMemo)(function() {
        return (ref1 = config/* LANGUAGES.find */.a2.find(function(language) {
            return language.value === i18n.language;
        })) !== null && ref1 !== void 0 ? ref1 : config/* LANGUAGES.0 */.a2[0];
    }, [
        langStorage
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var ref;
        var langStorageParsed = (ref = config/* LANGUAGES.find */.a2.find(function(language) {
            return language.value === langStorage;
        })) !== null && ref !== void 0 ? ref : config/* LANGUAGES.0 */.a2[0];
        push(asPath, asPath, {
            locale: langStorageParsed.path
        });
    }, [
        langStorage
    ]);
    var handleChangeLanguage = function(newLang) {
        if (newLang !== currentLang) {
            onChangeDirectionByLang(newLang.value);
            user === null || user === void 0 ? void 0 : user.update({
                unsafeMetadata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user.unsafeMetadata), {
                    lang: newLang.value
                })
            });
        }
    };
    (0,react.useEffect)(function() {
        (0,es/* setLocale */.i_)(config/* yupValidationLanguage */.Ll);
    }, [
        currentLang
    ]);
    return {
        onChangeLang: handleChangeLanguage,
        currentLang: currentLang,
        allLangs: config/* LANGUAGES */.a2
    };
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/header/LanguagePopover.tsx










function LanguagePopover() {
    var ref = useLocales(), allLangs = ref.allLangs, currentLang = ref.currentLang, onChangeLang = ref.onChangeLang;
    var ref1 = (0,react.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var handleChangeLang = function(newLang) {
        onChangeLang(newLang);
        handleClose();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                arrow: true,
                title: "Taal",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
                    onClick: handleOpen,
                    sx: (0,_object_spread/* default */.Z)({
                        width: 40,
                        height: 40
                    }, open && {
                        bgcolor: "action.selected"
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                        disabledEffect: true,
                        src: currentLang.icon,
                        alt: currentLang.label
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPopover, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 180,
                    "& .MuiMenuItem-root": {
                        px: 1,
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                    spacing: 0.75,
                    children: allLangs.map(function(option) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem/* default */.Z, {
                            selected: option.value === currentLang.value,
                            onClick: function() {
                                return handleChangeLang(option);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                    disabledEffect: true,
                                    alt: option.label,
                                    src: option.icon,
                                    sx: {
                                        width: 28,
                                        mr: 2
                                    }
                                }),
                                option.label
                            ]
                        }, option.value);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(72347);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Badge/Badge.js + 6 modules
var Badge = __webpack_require__(33821);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(19594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(95309);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(20293);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/no-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(1902);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/other/Scrollbar.tsx + 26 modules
var Scrollbar = __webpack_require__(23909);
// EXTERNAL MODULE: ./src/utils/formatTime.ts
var formatTime = __webpack_require__(69127);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/NotificationsPopover.tsx























function renderContent(notification) {
    var title = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
        variant: "subtitle2",
        children: [
            notification.title,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                sx: {
                    color: "text.secondary"
                },
                children: [
                    "\xa0 ",
                    (0,dist_es2015/* noCase */.B)(notification.description)
                ]
            })
        ]
    });
    if (notification.type === "order_placed") {
        return {
            avatar: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                alt: notification.title,
                src: "https://minimal-assets-api-dev.vercel.app/assets/icons/ic_notification_package.svg"
            }),
            title: title
        };
    }
    if (notification.type === "order_shipped") {
        return {
            avatar: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                alt: notification.title,
                src: "https://minimal-assets-api-dev.vercel.app/assets/icons/ic_notification_shipping.svg"
            }),
            title: title
        };
    }
    if (notification.type === "mail") {
        return {
            avatar: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                alt: notification.title,
                src: "https://minimal-assets-api-dev.vercel.app/assets/icons/ic_notification_mail.svg"
            }),
            title: title
        };
    }
    if (notification.type === "chat_message") {
        return {
            avatar: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                alt: notification.title,
                src: "https://minimal-assets-api-dev.vercel.app/assets/icons/ic_notification_chat.svg"
            }),
            title: title
        };
    }
    return {
        avatar: notification.avatar ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            alt: notification.title,
            src: notification.avatar
        }) : null,
        title: title
    };
}
function NotificationItem(param) {
    var notification = param.notification;
    var ref = renderContent(notification), avatar = ref.avatar, title = ref.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItemButton/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            py: 1.5,
            px: 2.5,
            mt: "1px"
        }, notification.isUnRead && {
            bgcolor: "action.selected"
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                    sx: {
                        bgcolor: "background.neutral"
                    },
                    children: avatar
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemText/* default */.Z, {
                primary: title,
                secondary: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                    variant: "caption",
                    sx: {
                        mt: 0.5,
                        display: "flex",
                        alignItems: "center",
                        color: "text.disabled"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                            icon: "eva:clock-outline",
                            sx: {
                                mr: 0.5,
                                width: 16,
                                height: 16
                            }
                        }),
                        (0,formatTime/* fToNow */.DY)(notification.createdAt)
                    ]
                })
            })
        ]
    });
}
function NotificationsPopover() {
    var ref = (0,react.useState)([]), notifications = ref[0], setNotifications = ref[1];
    var totalUnRead = notifications.filter(function(item) {
        return item.isUnRead === true;
    }).length;
    var ref1 = (0,react.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var handleMarkAllAsRead = function() {
        setNotifications(notifications.map(function(notification) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, notification), {
                isUnRead: false
            });
        }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                arrow: true,
                title: "Notificaties",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
                    color: open ? "primary" : "default",
                    onClick: handleOpen,
                    sx: {
                        width: 40,
                        height: 40
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                        badgeContent: totalUnRead,
                        color: "error",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                            icon: "la:bell-solid",
                            width: 25,
                            height: 25
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuPopover, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    width: 360,
                    p: 0,
                    mt: 1.5,
                    ml: 0.75
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            py: 2,
                            px: 2.5
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                sx: {
                                    flexGrow: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: "Notificaties"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: [
                                            "Je hebt ",
                                            totalUnRead,
                                            " ongelezen berichten"
                                        ]
                                    })
                                ]
                            }),
                            totalUnRead > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                title: " Mark all as read",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
                                    color: "primary",
                                    onClick: handleMarkAllAsRead,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                                        icon: "eva:done-all-fill",
                                        width: 20,
                                        height: 20
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Scrollbar/* default */.Z, {
                        sx: {
                            height: {
                                xs: 340,
                                sm: "auto"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
                                disablePadding: true,
                                subheader: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSubheader/* default */.Z, {
                                    disableSticky: true,
                                    sx: {
                                        py: 1,
                                        px: 2.5,
                                        typography: "overline"
                                    },
                                    children: "Nieuw"
                                }),
                                children: notifications.slice(0, 2).map(function(notification) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationItem, {
                                        notification: notification
                                    }, notification.id);
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
                                disablePadding: true,
                                subheader: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSubheader/* default */.Z, {
                                    disableSticky: true,
                                    sx: {
                                        py: 1,
                                        px: 2.5,
                                        typography: "overline"
                                    },
                                    children: "Recent"
                                }),
                                children: notifications.slice(2, 5).map(function(notification) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationItem, {
                                        notification: notification
                                    }, notification.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            p: 1
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                            disabled: true,
                            fullWidth: true,
                            disableRipple: true,
                            children: "Bekijk alles"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Input/Input.js
var Input = __webpack_require__(76866);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slide/Slide.js
var Slide = __webpack_require__(25425);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/Searchbar.tsx















var APPBAR_MOBILE = 64;
var APPBAR_DESKTOP = 92;
var SearchbarStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), (0,_define_property/* default */.Z)({
        top: 0,
        left: 0,
        zIndex: 99,
        width: "100%",
        display: "flex",
        position: "absolute",
        alignItems: "center",
        height: APPBAR_MOBILE,
        padding: theme.spacing(0, 3),
        boxShadow: theme.customShadows.z8
    }, theme.breakpoints.up("md"), {
        height: APPBAR_DESKTOP,
        padding: theme.spacing(0, 5)
    }));
});
function Searchbar() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var handleOpen = function() {
        setOpen(function(previous) {
            return !previous;
        });
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickAwayListener/* default */.Z, {
        onClickAway: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [
                !isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
                    onClick: handleOpen,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                        icon: "eva:search-fill",
                        width: 20,
                        height: 20
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide/* default */.Z, {
                    direction: "down",
                    in: isOpen,
                    mountOnEnter: true,
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchbarStyle, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, {
                                autoFocus: true,
                                fullWidth: true,
                                disableUnderline: true,
                                placeholder: "Zoeken…",
                                startAdornment: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAdornment/* default */.Z, {
                                    position: "start",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                                        icon: "eva:search-fill",
                                        sx: {
                                            color: "text.disabled",
                                            width: 20,
                                            height: 20
                                        }
                                    })
                                }),
                                sx: {
                                    mr: 1,
                                    fontWeight: "fontWeightBold"
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                variant: "contained",
                                onClick: handleClose,
                                children: "Search"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/header/index.tsx























var RootStyle = (0,styled/* default */.ZP)(AppBar/* default */.Z, {
    shouldForwardProp: function(property) {
        return property !== "isCollapse" && property !== "isOffset" && property !== "verticalLayout";
    }
})(function(param) {
    var isCollapse = param.isCollapse, isOffset = param.isOffset, verticalLayout = param.verticalLayout, theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), (0,_define_property/* default */.Z)({
        boxShadow: "none",
        height: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT,
        zIndex: theme.zIndex.appBar + 1,
        transition: theme.transitions.create([
            "width",
            "height"
        ], {
            duration: theme.transitions.duration.shorter
        })
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        height: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH + 1, "px)")
    }, isCollapse && {
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH, "px)")
    }, isOffset && {
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT
    }, verticalLayout && {
        width: "100%",
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    })));
});
function DashboardHeader(param) {
    var onOpenSidebar = param.onOpenSidebar, _isCollapse = param.isCollapse, isCollapse = _isCollapse === void 0 ? false : _isCollapse, _verticalLayout = param.verticalLayout, verticalLayout = _verticalLayout === void 0 ? false : _verticalLayout;
    var isOffset = useOffSetTop(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RootStyle, {
        isCollapse: isCollapse,
        isOffset: isOffset,
        verticalLayout: verticalLayout,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Toolbar/* default */.Z, {
            sx: {
                minHeight: themeStretch ? null : "100% !important",
                px: {
                    lg: 5
                }
            },
            children: [
                isDesktop && verticalLayout && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                    sx: {
                        mr: 2.5
                    }
                }),
                !isDesktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
                    onClick: onOpenSidebar,
                    sx: {
                        mr: 1,
                        color: "text.primary"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                        icon: "eva:menu-2-fill"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Searchbar, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: {
                        xs: 0.5,
                        sm: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist.OrganizationSwitcher, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationsPopover, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguagePopover, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SettingsButton, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                            arrow: true,
                            title: "Account",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist.UserButton, {})
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
;// CONCATENATED MODULE: ./src/components/nav-section/index.ts


function isExternalLink(path) {
    return path.includes("http");
}
function getActive(path, pathname, asPath) {
    var checkPath = path.startsWith("#");
    if (path !== "/") {
        return !checkPath && pathname.includes(path) || !checkPath && asPath.includes(path);
    }
    if (pathname === path) {
        return true;
    }
    return false;
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/style.ts







var ListItemStyle = (0,styled/* default */.ZP)(ListItemButton/* default */.Z, {
    shouldForwardProp: function(property) {
        return property !== "active" && property !== "open";
    }
})(function(param) {
    var active = param.active, depth = param.depth, open = param.open, theme = param.theme;
    var isLight = theme.palette.mode === "light";
    var activeStyle = {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.common.white,
        boxShadow: "-2px 4px 6px 0 ".concat((0,colorManipulator/* alpha */.Fq)(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.16))
    };
    var activeSubStyle = {
        boxShadow: "none",
        color: theme.palette.primary.main,
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    };
    var hoverStyle = {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover,
        boxShadow: "inset 0 0 1px 1px ".concat(theme.palette.divider)
    };
    return (0,_object_spread/* default */.Z)({
        textTransform: "capitalize",
        margin: theme.spacing(0, 0.5),
        padding: theme.spacing(0, 1),
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius,
        height: config/* NAVBAR.DASHBOARD_ITEM_HORIZONTAL_HEIGHT */.Au.DASHBOARD_ITEM_HORIZONTAL_HEIGHT,
        "&:hover": hoverStyle
    }, active && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeStyle), {
        "&:hover": (0,_object_spread/* default */.Z)({}, activeStyle)
    }), active && depth !== 1 && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeSubStyle), {
        "&:hover": (0,_object_spread/* default */.Z)({}, activeSubStyle)
    }), depth && (0,_object_spread/* default */.Z)({}, depth > 1 && {
        width: "100%",
        margin: 0,
        paddingRight: 0,
        paddingLeft: theme.spacing(1)
    }), open && !active && hoverStyle);
});
var PaperStyle = (0,styled/* default */.ZP)(Popover/* default */.ZP)(function(param) {
    var theme = param.theme;
    return {
        pointerEvents: "none",
        "& .MuiPopover-paper": (0,_object_spread/* default */.Z)({
            width: 160,
            pointerEvents: "auto",
            padding: theme.spacing(1),
            marginTop: theme.spacing(0.5),
            boxShadow: theme.customShadows.dropdown,
            borderRadius: Number(theme.shape.borderRadius) * 1.5
        }, (0,cssStyles/* default */.Z)(theme).bgBlur())
    };
});

;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/NavItem.tsx












var NavItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, reference) {
    var item = _param.item, depth = _param.depth, active = _param.active, open = _param.open, other = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "depth",
        "active",
        "open"
    ]);
    var title = item.title, icon = item.icon, info = item.info, children = item.children, disabled = item.disabled, caption = item.caption;
    var renderContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItemStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: reference,
        open: open,
        depth: depth,
        active: active,
        disabled: disabled
    }, other), {
        children: [
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIcon/* default */.Z, {
                sx: {
                    mr: 1,
                    flexShrink: 0,
                    width: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL,
                    height: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL
                },
                children: icon
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemText/* default */.Z, {
                primary: title,
                primaryTypographyProps: {
                    noWrap: true,
                    variant: active ? "subtitle2" : "body2"
                }
            }),
            caption && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                title: caption,
                arrow: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        ml: 0.5,
                        lineHeight: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                        icon: "eva:info-outline",
                        sx: {
                            width: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL / -4,
                            height: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL / -4
                        }
                    })
                })
            }),
            info && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                component: "span",
                sx: {
                    ml: 1,
                    lineHeight: 0
                },
                children: info
            }),
            !!children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                icon: depth > 1 ? "eva:chevron-right-fill" : "eva:chevron-down-fill",
                sx: {
                    ml: 0.5,
                    flexShrink: 0,
                    width: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL,
                    height: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL
                }
            })
        ]
    }));
    return renderContent;
});
/* harmony default export */ var horizontal_NavItem = (NavItem);

;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/NavList.tsx







function NavList(param) {
    var data = param.data, depth = param.depth, hasChildren = param.hasChildren;
    var menuReference = (0,react.useRef)(null);
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath, push = ref.push;
    var active = getActive(data.path, pathname, asPath);
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    (0,react.useEffect)(function() {
        if (open) {
            handleClose();
        }
    }, [
        pathname
    ]);
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var handleClickItem = function() {
        if (!hasChildren) {
            push(data.path);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isExternalLink(data.path) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                href: data.path,
                target: "_blank",
                rel: "noopener",
                underline: "none",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(horizontal_NavItem, {
                    item: data,
                    depth: depth,
                    open: open,
                    active: active
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(horizontal_NavItem, {
                item: data,
                depth: depth,
                open: open,
                active: active,
                ref: menuReference,
                onClick: handleClickItem,
                onMouseEnter: handleOpen,
                onMouseLeave: handleClose
            }),
            hasChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyle, {
                open: open,
                anchorEl: menuReference.current,
                anchorOrigin: depth === 1 ? {
                    vertical: "bottom",
                    horizontal: "left"
                } : {
                    vertical: "center",
                    horizontal: "right"
                },
                transformOrigin: depth === 1 ? {
                    vertical: "top",
                    horizontal: "left"
                } : {
                    vertical: "center",
                    horizontal: "left"
                },
                PaperProps: {
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavSubList, {
                    data: data.children,
                    depth: depth
                })
            })
        ]
    });
}
function NavSubList(param) {
    var data = param.data, depth = param.depth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: data.map(function(list) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavList, {
                data: list,
                depth: depth + 1,
                hasChildren: !!list.children
            }, list.title + list.path);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/index.tsx






var hideScrollbar = {
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
        display: "none"
    }
};
function NavSectionHorizontal(param) {
    var navConfig = param.navConfig;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
        direction: "row",
        justifyContent: "center",
        sx: {
            bgcolor: "background.neutral",
            borderRadius: 1,
            px: 0.5
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
            direction: "row",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hideScrollbar), {
                py: 1
            }),
            children: navConfig.map(function(group) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                    direction: "row",
                    flexShrink: 0,
                    children: group.items.map(function(list) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavList, {
                            data: list,
                            depth: 1,
                            hasChildren: !!list.children
                        }, list.title + list.path);
                    })
                }, group.subheader);
            })
        })
    });
}
/* harmony default export */ var horizontal = (/*#__PURE__*/(0,react.memo)(NavSectionHorizontal));

// EXTERNAL MODULE: ./src/layouts/routes.ts
var routes = __webpack_require__(80600);
;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavConfig.tsx



var ICONS = {
    dashboard: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "la:chart-pie",
        width: 24,
        height: 24
    }),
    employees: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "la-users",
        width: 24,
        height: 24
    }),
    general: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "bi:person-lines-fill",
        width: 24,
        height: 24
    }),
    employment: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "clarity:contract-solid",
        width: 24,
        height: 24
    }),
    overview: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "ooui:view-details-ltr",
        width: 24,
        height: 24
    }),
    schedule: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "fa6-solid:calendar-day",
        width: 24,
        height: 24
    }),
    contracts: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "mingcute:paper-fill",
        width: 24,
        height: 24
    }),
    absence: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "mdi:bag-suitcase",
        width: 24,
        height: 24
    }),
    sickness: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "ic:round-sick",
        width: 24,
        height: 24
    }),
    competences: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "carbon:skill-level-intermediate",
        width: 24,
        height: 24
    }),
    material: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "ep:goods-filled",
        width: 24,
        height: 24
    }),
    documents: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "ic:round-perm-media",
        width: 24,
        height: 24
    }),
    account: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "mdi:account-cog",
        width: 24,
        height: 24
    }),
    workflow: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "la:file-alt",
        width: 24,
        height: 24
    }),
    tasks: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "la:tasks",
        width: 24,
        height: 24
    }),
    course: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "fluent-mdl2:education",
        width: 24,
        height: 24
    }),
    calendar: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "la:calendar",
        width: 24,
        height: 24
    }),
    declaration: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
        icon: "material-symbols:upload-file-rounded",
        width: 24,
        height: 24
    })
};
var navConfigEmployee = [
    {
        subheader: "Dashboard",
        subheader_icon: "/assets/icons/navbar/dashboard_subheader.svg",
        items: [
            {
                title: "Overzicht",
                path: routes/* ROUTES.home.root */.Z6.home.root,
                icon: ICONS.dashboard
            },
            {
                title: "Takenlijst",
                path: routes/* ROUTES.tasks.root */.Z6.tasks.root,
                icon: ICONS.tasks
            },
            {
                title: "Kalender",
                path: routes/* ROUTES.calendar.root */.Z6.calendar.root,
                icon: ICONS.calendar
            }, 
        ]
    },
    {
        subheader: "Collega's",
        subheader_icon: "/assets/icons/navbar/invoice_subheader.svg",
        items: [
            {
                title: "Algemeen",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "algemeen"),
                icon: ICONS.general
            },
            {
                title: "Dienstverband",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "dienstverband"),
                icon: ICONS.employment,
                children: [
                    {
                        title: "Overzicht",
                        path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "dienstverband", "overzicht")
                    },
                    {
                        title: "Contracten",
                        path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "dienstverband", "contracten")
                    }, 
                ]
            },
            {
                title: "Verlof",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "verlof"),
                icon: ICONS.absence
            },
            {
                title: "Verzuim",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "verzuim"),
                icon: ICONS.sickness
            },
            {
                title: "Competenties",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "competenties"),
                icon: ICONS.competences
            },
            {
                title: "Materiaal",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "materiaal"),
                icon: ICONS.material
            },
            {
                title: "Documenten",
                path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path(undefined, "documenten"),
                icon: ICONS.documents
            },
            {
                title: "Declaraties",
                path: routes/* ROUTES.declaration.list */.Z6.declaration.list,
                icon: ICONS.declaration
            }, 
        ]
    }, 
];
var navConfigAdministrator = [
    {
        subheader: "Dashboard",
        subheader_icon: "/assets/icons/navbar/dashboard_subheader.svg",
        items: [
            {
                title: "Overzicht",
                path: routes/* ROUTES.home.root */.Z6.home.root,
                icon: ICONS.dashboard
            },
            {
                title: "Takenlijst",
                path: routes/* ROUTES.tasks.root */.Z6.tasks.root,
                icon: ICONS.tasks
            },
            {
                title: "Workflows",
                path: routes/* ROUTES.workflow.root */.Z6.workflow.root,
                icon: ICONS.workflow
            },
            {
                title: "Kalender",
                path: routes/* ROUTES.calendar.root */.Z6.calendar.root,
                icon: ICONS.calendar
            }, 
        ]
    },
    {
        subheader: "Collega's",
        subheader_icon: "/assets/icons/navbar/invoice_subheader.svg",
        items: [
            {
                title: "Medewerkers",
                path: routes/* ROUTES.user.list.path */.Z6.user.list.path,
                icon: ICONS.employees,
                children: [
                    {
                        title: "Lijst",
                        path: routes/* ROUTES.user.list.path */.Z6.user.list.path
                    },
                    {
                        title: "Profiel",
                        path: routes/* ROUTES.user.profile.path */.Z6.user.profile.path()
                    },
                    {
                        title: "Nieuw",
                        path: routes/* ROUTES.user.create.path */.Z6.user.create.path
                    }, 
                ]
            },
            {
                title: "Contracten",
                path: routes/* ROUTES.contract.list */.Z6.contract.list,
                icon: ICONS.contracts
            },
            {
                title: "Declaraties",
                path: routes/* ROUTES.declaration.list */.Z6.declaration.list,
                icon: ICONS.declaration
            },
            {
                title: "Verlof",
                path: routes/* ROUTES.absence.list */.Z6.absence.list,
                icon: ICONS.absence
            },
            {
                title: "Verzuim",
                path: routes/* ROUTES.sickness.list */.Z6.sickness.list,
                icon: ICONS.sickness
            },
            {
                title: "Competenties",
                path: routes/* ROUTES.competence.list */.Z6.competence.list,
                icon: ICONS.competences
            }, 
        ]
    },
    {
        subheader: "Bedrijfsmiddelen",
        subheader_icon: "/assets/icons/navbar/stock_subheader.svg",
        items: [
            {
                title: "Materiaal",
                path: routes/* ROUTES.item.root */.Z6.item.root,
                icon: ICONS.material
            }, 
        ]
    },
    {
        subheader: "Cursussen",
        subheader_icon: "/assets/icons/navbar/planning_subheader.svg",
        items: [
            {
                title: "Opleidingen",
                path: routes/* ROUTES.course.root */.Z6.course.root,
                icon: ICONS.course
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarHorizontal.tsx









var NavbarHorizontal_RootStyle = (0,styled/* default */.ZP)(AppBar/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        transition: theme.transitions.create("top", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        }),
        width: "100%",
        position: "fixed",
        zIndex: theme.zIndex.appBar,
        padding: theme.spacing(1, 0),
        boxShadow: theme.customShadows.z8,
        top: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    };
});
function NavbarHorizontal() {
    var ref, ref1;
    var membership = (0,dist.useOrganization)().membership;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarHorizontal_RootStyle, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
            maxWidth: false,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(horizontal, {
                navConfig: ((ref1 = membership === null || membership === void 0 ? void 0 : (ref = membership.publicMetadata) === null || ref === void 0 ? void 0 : ref.hr) === null || ref1 === void 0 ? void 0 : ref1.role) === "administrator" ? navConfigAdministrator : navConfigEmployee
            })
        })
    });
}
/* harmony default export */ var navbar_NavbarHorizontal = (/*#__PURE__*/(0,react.memo)(NavbarHorizontal));

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(60684);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OfflineBolt.js
var OfflineBolt = __webpack_require__(39713);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
;// CONCATENATED MODULE: ./src/components/clerk/OrganizationSelector.tsx










var OrganizationSelector = function(param) {
    var onSelect = param.onSelect, textFieldProps = param.textFieldProps;
    var ref = (0,dist.useOrganizationList)(), setActive = ref.setActive, organizationList = ref.organizationList, isLoaded = ref.isLoaded;
    var organization = (0,dist.useOrganization)().organization;
    var ref1 = (0,react.useState)((organization === null || organization === void 0 ? void 0 : organization.id) || ""), activeOrg = ref1[0], setActiveOrg = ref1[1];
    var ref2 = (0,react.useState)([]), offlineHosts = ref2[0], setOfflineHosts = ref2[1];
    var ref3 = (0,react.useState)(false), initialized = ref3[0], setInitialized = ref3[1];
    // useEffect(() => {
    // 	const controller = new AbortController();
    // 	const { signal } = controller;
    // 	const pingBackend = async (slugs: string[]) => {
    // 		setInitialized(false);
    // 		// const offline = [];
    // 		// for (const slug of slugs) {
    // 			// eslint-disable-next-line no-await-in-loop -- The eslint proposed await Promise.all() fix is not compatible if we need to check res.ok status within for loop aswell.
    // 			// const response = await fetch(`https://${slug}.hasura.app/healthz`, { signal }); // TODO: Reenable the lines once we have a Hasura/Clerk app for each organization.
    // 			// if (!response.ok) {
    // 			// 	offline.push(slug);
    // 			// }
    // 		// }
    // 		// setOfflineHosts(offline);
    // 		setInitialized(true);
    // 	};;
    // 	if (isLoaded) {
    // 		const hosts = organizationList.map((org) => org.organization.slug);
    // 		pingBackend(hosts);
    // 	}
    // 	return () => controller.abort();
    // }, []);
    var isOffline = (0,react.useCallback)(function(slug) {
        return slug ? offlineHosts.includes(slug) : true;
    }, [
        offlineHosts
    ]);
    var getSelectedOrganization = (0,react.useCallback)(function(id) {
        if (id && (organizationList === null || organizationList === void 0 ? void 0 : organizationList.length)) {
            var ref;
            return (ref = organizationList.find(function(org) {
                return org.organization.id === id;
            })) === null || ref === void 0 ? void 0 : ref.organization;
        }
    }, [
        organizationList
    ]);
    if (!isLoaded) {
        return null;
    }
    var handleOrganizationChange = function(event) {
        var organization_id = event.target.value;
        if (!onSelect) {
            setActive({
                organization: organization_id
            });
        } else {
            onSelect(organization_id);
        }
        setActiveOrg(organization_id);
    };
    var sortedOrgList = organizationList.sort(function(a, b) {
        return isOffline(a.organization.slug) ? 1 : -1;
    });
    var ref4;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        label: "Organizatie"
    }, textFieldProps), {
        disabled: !initialized,
        SelectProps: {
            renderValue: function(value) {
                var ref, ref1;
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                    direction: "row",
                    gap: 1,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIcon/* default */.Z, {
                            sx: {
                                mr: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfflineBolt/* default */.Z, {
                                color: isOffline((ref4 = (ref = getSelectedOrganization(value)) === null || ref === void 0 ? void 0 : ref.slug) !== null && ref4 !== void 0 ? ref4 : "") ? "error" : "success"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: (ref1 = getSelectedOrganization(value)) === null || ref1 === void 0 ? void 0 : ref1.name
                        })
                    ]
                });
            }
        },
        select: true,
        value: activeOrg !== null && activeOrg !== void 0 ? activeOrg : organization === null || organization === void 0 ? void 0 : organization.id,
        onChange: handleOrganizationChange,
        children: sortedOrgList.sort(function(a, b) {
            return isOffline(a.organization.slug) ? 1 : -1;
        }).map(function(param) {
            var organization = param.organization;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem/* default */.Z, {
                disabled: isOffline(organization.slug),
                value: organization.id,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIcon/* default */.Z, {
                        sx: {
                            mr: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfflineBolt/* default */.Z, {
                            color: isOffline(organization.slug) ? "error" : "success"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: organization.name
                    })
                ]
            }, organization.id);
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/CollapseButton.tsx




function CollapseButton(param) {
    var onToggleCollapse = param.onToggleCollapse, collapseClick = param.collapseClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonAnimate/* default */.Z, {
        onClick: onToggleCollapse,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            sx: (0,_object_spread/* default */.Z)({
                lineHeight: 0,
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, collapseClick && {
                transform: "rotate(180deg)"
            }),
            children: collapseIcon
        })
    });
}
var collapseIcon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M14.3283 11.4343 18.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z",
                        opacity: ".48"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M8.3283 11.4343 12.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z"
                    })
                ]
            })
        ]
    })
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(93481);
;// CONCATENATED MODULE: ./src/components/nav-section/vertical/style.ts









var style_ListItemStyle = (0,styled/* default */.ZP)(ListItemButton/* default */.Z, {
    shouldForwardProp: function(property) {
        return property !== "active";
    }
})(function(param) {
    var active = param.active, depth = param.depth, theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        position: "relative",
        textTransform: "capitalize",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius,
        height: config/* NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT */.Au.DASHBOARD_ITEM_ROOT_HEIGHT
    }, active && {
        color: theme.palette.primary.main,
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }, active && depth !== 1 && {
        color: theme.palette.text.primary,
        backgroundColor: "transparent"
    }, depth && (0,_object_spread/* default */.Z)({}, depth > 1 && {
        height: config/* NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT */.Au.DASHBOARD_ITEM_SUB_HEIGHT
    }, depth > 2 && {
        paddingLeft: theme.spacing(depth)
    }));
});
var ListItemTextStyle = (0,styled/* default */.ZP)(ListItemText/* default */.Z, {
    shouldForwardProp: function(property) {
        return property !== "isCollapse";
    }
})(function(param) {
    var isCollapse = param.isCollapse, theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        transition: theme.transitions.create([
            "width",
            "opacity"
        ], {
            duration: theme.transitions.duration.shorter
        })
    }, isCollapse && {
        width: 0,
        opacity: 0
    });
});
var ListItemIconStyle = (0,styled/* default */.ZP)(ListItemIcon/* default */.Z)({
    width: config/* ICON.NAVBAR_ITEM */.Wm.NAVBAR_ITEM,
    height: config/* ICON.NAVBAR_ITEM */.Wm.NAVBAR_ITEM,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
        width: "100%",
        height: "100%"
    }
});
var ListSubheaderStyle = (0,styled/* default */.ZP)(ListSubheader/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.overline), {
        borderRadius: theme.shape.borderRadius,
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(0.5),
        marginBottom: theme.spacing(1),
        color: theme.palette.text.primary,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    }), (0,cssStyles/* default */.Z)(theme).bgBlur());
});

;// CONCATENATED MODULE: ./src/components/nav-section/vertical/NavItem.tsx








function NavItem_NavItem(_param) {
    var item = _param.item, depth = _param.depth, active = _param.active, open = _param.open, isCollapse = _param.isCollapse, other = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "depth",
        "active",
        "open",
        "isCollapse"
    ]);
    var title = item.title, icon = item.icon, info = item.info, children = item.children, disabled = item.disabled, caption = item.caption;
    var renderContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
        title: isCollapse && caption ? caption : "",
        arrow: true,
        placement: "right",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(style_ListItemStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            depth: depth,
            active: active,
            disabled: disabled
        }, other), {
            children: [
                icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIconStyle, {
                    children: icon
                }),
                depth !== 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DotIcon, {
                    active: active && depth !== 1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemTextStyle, {
                    isCollapse: isCollapse,
                    primary: title,
                    secondary: caption && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: caption
                    }),
                    primaryTypographyProps: {
                        noWrap: true,
                        variant: active ? "subtitle2" : "body2"
                    },
                    secondaryTypographyProps: {
                        noWrap: true,
                        variant: "caption"
                    }
                }),
                !isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        info && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            component: "span",
                            sx: {
                                lineHeight: 0
                            },
                            children: info
                        }),
                        !!children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Iconify/* default */.Z, {
                            icon: open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill",
                            sx: {
                                width: 16,
                                height: 16,
                                ml: 1,
                                flexShrink: 0
                            }
                        })
                    ]
                })
            ]
        }))
    });
    return renderContent;
}
function DotIcon(param) {
    var active = param.active;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIconStyle, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            component: "span",
            sx: (0,_object_spread/* default */.Z)({
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled",
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, active && {
                transform: "scale(2)",
                bgcolor: "primary.main"
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/vertical/NavList.tsx








function NavList_NavList(param) {
    var data = param.data, depth = param.depth, hasChildren = param.hasChildren, _isCollapse = param.isCollapse, isCollapse = _isCollapse === void 0 ? false : _isCollapse;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath, push = ref.push;
    var active = getActive(data.path, pathname, asPath);
    var ref1 = (0,react.useState)(active), open = ref1[0], setOpen = ref1[1];
    var handleClickItem = function() {
        if (!hasChildren) {
            push(data.path);
        }
        setOpen(!open);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isExternalLink(data.path) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                href: data.path,
                target: "_blank",
                rel: "noopener",
                underline: "none",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavItem_NavItem, {
                    item: data,
                    depth: depth,
                    open: open,
                    active: active,
                    isCollapse: isCollapse
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavItem_NavItem, {
                item: data,
                depth: depth,
                open: open,
                active: active,
                isCollapse: isCollapse,
                onClick: handleClickItem
            }),
            !isCollapse && hasChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collapse/* default */.Z, {
                in: open,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavList_NavSubList, {
                        data: data.children,
                        depth: depth
                    })
                })
            })
        ]
    });
}
function NavList_NavSubList(param) {
    var data = param.data, depth = param.depth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: data.map(function(list) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavList_NavList, {
                data: list,
                depth: depth + 1,
                hasChildren: !!list.children
            }, list.title + list.path);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/vertical/index.tsx

















function NavSectionVertical(_param) {
    var navConfig = _param.navConfig, isCollapse = _param.isCollapse, other = (0,_object_without_properties/* default */.Z)(_param, [
        "navConfig",
        "isCollapse"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,react.useState)(function() {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navConfig.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), index = _value[0], group = _value[1];
                json[group.subheader] = index === 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return json;
    }), open = ref[0], setOpen = ref[1];
    var ref1 = (0,router.useRouter)(), pathname = ref1.pathname, asPath = ref1.asPath;
    // Always open the active group on load
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navConfig[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var group = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = group.items[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var item = _step1.value;
                        var active = getActive(item.path, pathname, asPath);
                        if (active) {
                            setOpen(function(previous) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previous), (0,_define_property/* default */.Z)({}, group.subheader, true));
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        navConfig,
        pathname
    ]);
    var groupHasActive = (0,react.useCallback)(function(group) {
        return group.items.find(function(item) {
            return getActive(item.path, pathname, asPath);
        }) !== undefined;
    }, [
        pathname,
        asPath
    ]);
    var handleClick = function(group) {
        setOpen(function(previous) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previous), (0,_define_property/* default */.Z)({}, group.subheader, !previous[group.subheader]));
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: navConfig.map(function(group) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List/* default */.Z, {
                disablePadding: true,
                sx: {
                    px: 2
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListSubheaderStyle, {
                        disableGutters: true,
                        onClick: function() {
                            if (!groupHasActive(group)) {
                                handleClick(group);
                            }
                        },
                        sx: (0,_object_spread/* default */.Z)({
                            display: "flex",
                            gap: 2,
                            cursor: groupHasActive(group) ? "cursor" : "pointer",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }, open[group.subheader] && {
                            color: groupHasActive(group) && theme.palette.primary.main,
                            backgroundColor: isCollapse && (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                        }),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                title: isCollapse && !groupHasActive(group) ? "".concat(open[group.subheader] ? "Hide" : "Show") : "",
                                arrow: true,
                                placement: "right",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                    gap: 2,
                                    alignItems: "center",
                                    direction: "row",
                                    children: [
                                        group.subheader_icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                            component: "img",
                                            alt: "subheader icon",
                                            sx: {
                                                width: 25,
                                                height: 25
                                            },
                                            src: group.subheader_icon
                                        }),
                                        !isCollapse && group.subheader
                                    ]
                                })
                            }),
                            !isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                sx: (0,_object_spread/* default */.Z)({
                                    lineHeight: 0,
                                    transform: "rotate(90deg)",
                                    transition: function(theme) {
                                        return theme.transitions.create("transform", {
                                            duration: theme.transitions.duration.shorter
                                        });
                                    }
                                }, open[group.subheader] && {
                                    transform: "rotate(270deg)"
                                }),
                                children: collapseIcon
                            })
                        ]
                    }),
                    open[group.subheader] && group.items.map(function(list) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavList_NavList, {
                            data: list,
                            depth: 1,
                            hasChildren: !!list.children,
                            isCollapse: isCollapse
                        }, list.title + list.path);
                    })
                ]
            }, group.subheader);
        })
    }));
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarAccount.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- Clerk membership prop typing is unknown record */ 







var NavbarAccount_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2, 2.5),
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        backgroundColor: theme.palette.grey[50012],
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
});
function NavbarAccount(param) {
    var isCollapse = param.isCollapse;
    var ref, ref1;
    var user = (0,dist.useUser)().user;
    var membership = (0,dist.useOrganization)().membership;
    var getRoleText = function(role) {
        switch(role){
            case "administrator":
                {
                    return "Beheerder";
                }
            case "manager":
                {
                    return "Manager";
                }
            case "employee":
                {
                    return "Medewerker";
                }
            case null:
                {
                    return "Geen rol";
                }
            case undefined:
                {
                    return "Onbekende rol";
                }
            default:
                {
                    return "Geen rol";
                }
        }
    };
    var ref2;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
        underline: "none",
        color: "inherit",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarAccount_RootStyle, {
            sx: (0,_object_spread/* default */.Z)({}, isCollapse && {
                bgcolor: "transparent"
            }),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                    src: user === null || user === void 0 ? void 0 : user.profileImageUrl,
                    alt: (ref2 = user === null || user === void 0 ? void 0 : user.fullName) !== null && ref2 !== void 0 ? ref2 : ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    sx: (0,_object_spread/* default */.Z)({
                        ml: 2,
                        transition: function(theme) {
                            return theme.transitions.create("width", {
                                duration: theme.transitions.duration.shorter
                            });
                        }
                    }, isCollapse && {
                        ml: 0,
                        width: 0
                    }),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "subtitle2",
                            noWrap: true,
                            children: user === null || user === void 0 ? void 0 : user.fullName
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "body2",
                            noWrap: true,
                            sx: {
                                color: "text.secondary"
                            },
                            children: getRoleText((ref1 = membership === null || membership === void 0 ? void 0 : (ref = membership.publicMetadata) === null || ref === void 0 ? void 0 : ref.hr) === null || ref1 === void 0 ? void 0 : ref1.role)
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarVertical.tsx





















var NavbarVertical_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("lg"), {
        flexShrink: 0,
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.shorter
        })
    });
});
function NavbarVertical(param) {
    var isOpenSidebar = param.isOpenSidebar, onCloseSidebar = param.onCloseSidebar;
    var ref, ref1;
    var theme = (0,useTheme/* default */.Z)();
    var membership = (0,dist.useOrganization)().membership;
    var pathname = (0,router.useRouter)().pathname;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref2 = hooks_useCollapseDrawer(), isCollapse = ref2.isCollapse, collapseClick = ref2.collapseClick, collapseHover = ref2.collapseHover, onToggleCollapse = ref2.onToggleCollapse;
    (0,react.useEffect)(function() {
        if (isOpenSidebar) {
            onCloseSidebar();
        }
    }, [
        pathname
    ]);
    var renderContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Scrollbar/* default */.Z, {
        sx: {
            height: 1,
            "& .simplebar-content": {
                height: 1,
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                spacing: 3,
                sx: (0,_object_spread/* default */.Z)({
                    pt: 3,
                    pb: 2,
                    px: 2.5,
                    flexShrink: 0
                }, isCollapse && {
                    alignItems: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                gap: 2,
                                children: [
                                    isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapseButton, {
                                        onToggleCollapse: onToggleCollapse,
                                        collapseClick: collapseClick
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                                        full: !isCollapse
                                    })
                                ]
                            }),
                            isDesktop && !isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapseButton, {
                                onToggleCollapse: onToggleCollapse,
                                collapseClick: collapseClick
                            })
                        ]
                    }),
                    !isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarAccount, {
                        isCollapse: isCollapse
                    }),
                    !isCollapse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrganizationSelector, {
                        textFieldProps: {
                            size: "small",
                            label: "",
                            fullWidth: true
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavSectionVertical, {
                navConfig: ((ref1 = membership === null || membership === void 0 ? void 0 : (ref = membership.publicMetadata) === null || ref === void 0 ? void 0 : ref.hr) === null || ref1 === void 0 ? void 0 : ref1.role) === "administrator" ? navConfigAdministrator : navConfigEmployee,
                isCollapse: isCollapse
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarVertical_RootStyle, {
        sx: (0,_object_spread/* default */.Z)({
            width: {
                lg: isCollapse ? config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH : config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
            }
        }, collapseClick && {
            position: "absolute"
        }),
        children: [
            !isDesktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP, {
                open: isOpenSidebar,
                onClose: onCloseSidebar,
                PaperProps: {
                    sx: {
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
                    }
                },
                children: renderContent
            }),
            isDesktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP, {
                open: true,
                variant: "persistent",
                PaperProps: {
                    sx: (0,_object_spread/* default */.Z)({
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH,
                        borderRightStyle: "dashed",
                        bgcolor: "background.default",
                        transition: function(theme) {
                            return theme.transitions.create("width", {
                                duration: theme.transitions.duration.standard
                            });
                        }
                    }, isCollapse && {
                        width: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
                    }, collapseHover && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), {
                        boxShadow: function(theme) {
                            return theme.customShadows.z24;
                        }
                    }))
                },
                children: renderContent
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/index.tsx













var MainStyle = (0,styled/* default */.ZP)("main", {
    shouldForwardProp: function(property) {
        return property !== "collapseClick";
    }
})(function(param) {
    var collapseClick = param.collapseClick, theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flexGrow: 1,
        paddingTop: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24,
        paddingBottom: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: collapseClick ? config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 0 : config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        paddingBottom: collapseClick ? config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 0 : config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH, "px)"),
        transition: theme.transitions.create("margin-left", {
            duration: theme.transitions.duration.shorter
        })
    }, collapseClick && {
        marginLeft: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
    }));
});
function DashboardLayout(param) {
    var children = param.children;
    var ref = hooks_useCollapseDrawer(), collapseClick = ref.collapseClick, isCollapse = ref.isCollapse;
    var ref1 = (0,useSettings/* default */.Z)(), themeLayout = ref1.themeLayout, themeMode = ref1.themeMode, themeStretch = ref1.themeStretch;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var verticalLayout = themeLayout === "vertical";
    if (verticalLayout) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DashboardHeader, {
                    onOpenSidebar: function() {
                        return setOpen(true);
                    },
                    verticalLayout: verticalLayout
                }),
                isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbar_NavbarHorizontal, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarVertical, {
                    isOpenSidebar: open,
                    onCloseSidebar: function() {
                        return setOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    component: "main",
                    sx: {
                        px: {
                            lg: 2
                        },
                        pt: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 80, "px")
                        },
                        pb: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24, "px")
                        }
                    },
                    children: children
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        sx: {
            display: {
                lg: "flex"
            },
            minHeight: {
                lg: 1
            },
            "::before": {
                content: '""',
                background: 'url("/assets/background-image-no-line.webp")',
                filter: themeMode === "dark" ? "invert(100%) grayscale(100%)" : "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 130%",
                position: "fixed",
                zIndex: -10000000,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0.2
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DashboardHeader, {
                isCollapse: isCollapse,
                onOpenSidebar: function() {
                    return setOpen(true);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarVertical, {
                isOpenSidebar: open,
                onCloseSidebar: function() {
                    return setOpen(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainStyle, {
                collapseClick: collapseClick,
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/LogoOnlyLayout.tsx




var HeaderStyle = (0,styled/* default */.ZP)("header")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        top: 0,
        left: 0,
        lineHeight: 0,
        width: "100%",
        position: "absolute",
        padding: theme.spacing(3, 3, 0)
    }, theme.breakpoints.up("sm"), {
        padding: theme.spacing(5, 5, 0)
    });
});
function LogoOnlyLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderStyle, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {})
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/index.tsx



function Layout(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "dashboard" : _variant, children = param.children;
    if (variant === "logoOnly") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoOnlyLayout, {
            children: [
                " ",
                children,
                " "
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DashboardLayout, {
        children: [
            " ",
            children,
            " "
        ]
    });
}


/***/ }),

/***/ 69127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ fToNow; },
/* harmony export */   "Mu": function() { return /* binding */ fDate; },
/* harmony export */   "Ug": function() { return /* binding */ fDateTimeEu; },
/* harmony export */   "j4": function() { return /* binding */ getHoursAndMinutesFromDate; },
/* harmony export */   "kM": function() { return /* binding */ fDateShort; }
/* harmony export */ });
/* unused harmony exports fDateNA, fDateTime, fTimestamp, fDateTimeEuSmallYear, fDateTimeEuSmall, fTimeEuSmall, fDateTimeSuffix */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32912);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2141);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94638);


function fDate(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
    if (date) return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(date), "dd MMMM yyyy", {
        locale: locale
    });
}
function fDateNA(date) {
    return format(new Date(date), "dd MMMM yyyy");
}
function fDateShort(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(date), "dd-MM-yyyy", {
        locale: locale
    });
}
function fDateTime(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nl;
    return format(new Date(date), "dd MMM yyyy p", {
        locale: locale
    });
}
function fTimestamp(date) {
    return getTime(new Date(date));
}
function fDateTimeEu(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
    if (!date) return "";
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(date), "dd-MM-yyyy HH:mm", {
        locale: locale
    });
}
function fDateTimeEuSmallYear(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nl;
    return format(new Date(date), "dd-MM-yy HH:mm", {
        locale: locale
    });
}
function fDateTimeEuSmall(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nl;
    return format(new Date(date), "dd-MM HH:mm", {
        locale: locale
    });
}
function fTimeEuSmall(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nl;
    return format(new Date(date), "HH:mm", {
        locale: locale
    });
}
function fDateTimeSuffix(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nl;
    return format(new Date(date), "dd-MM-yyyy hh:mm p", {
        locale: locale
    });
}
function fToNow(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), {
        addSuffix: true,
        locale: locale
    });
}
/**
 * Used to properly format times for use in the calendar
 * @param number that needs a zero in front.
 * @returns the number with a zero in front if it is smaller than 10.
 */ var addZero = function(number) {
    return number < 10 ? "0".concat(number) : number;
};
/**
 * Fullcalendar package requires recurring event start/end times
 * consisting of hours and minutes instead of a whole date.
 * @param date to extract the time from.
 * @returns a formatted string consisting of hours and minutes.
 */ function getHoursAndMinutesFromDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    return "".concat(String(addZero(hours)), ":").concat(String(addZero(minutes)));
}


/***/ })

}]);